// Actions
export const STARTTIMER = "global/STARTTIMER";
export const ENDTIMER = "global/ENDTIMER";
export const FULLTIMER = "global/FULLTIMER";

export const defaultScopeId = "performance";

// Reducer
export default function reducer(state = { timers: {} }, { type, data } = {} ) {
    const timer = `${data?.name}-${data?.item || "" }`;
    switch (type) {
    case "@@INIT": {
        return { ...state, init: true };
    }
    case STARTTIMER:
        if(!data){
            Promise.reject(new Error("Start time does not exist when storing start time in monitor"));
            return state;
        }
        
        state.timers[timer] = { start: data.time };
        return {
            ...state
        };
    case ENDTIMER:
        if(state.timers[timer] && !data) {
            Promise.reject(new Error("End time does not exist when assigning end time in monitor"));
            return state;
        }
        
        if(state.timers[timer])
            state.timers[timer].end = data.time;
        return { ...state };
    case FULLTIMER:
        if(!data){
            Promise.reject(new Error("Time does not exist when storing start and end time to monitor"));
            return state;
        }

        state.timers[timer] = {
            start: data.start,
            end : data.end
        };
        return { ...state };
    default: return state;
    }
}

// Action Creators
export function startTimer(name) {
    return { type: STARTTIMER, data: { name, time: performance.now() } };
}

export function endTimer(name) {
    return { type: ENDTIMER, data : { name, time: performance.now() } };
}
